import {
  CheckCircleIcon,
  EllipsisHorizontalCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/20/solid';
import { appRevisionStateToString } from '../../helpers/util';
import { CircularProgress } from '../core/circular_progress';

interface IncarnationStateBadgeProps {
  state: number;
}

export function IncarnationStateBadge(props: IncarnationStateBadgeProps) {
  return (
    <span className="flex items-center text-sm text-gray-500">
      {appRevisionStateToString(props.state) === 'Rendered' && (
        <CheckCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-400"
          aria-hidden="true"
        />
      )}
      {appRevisionStateToString(props.state) === 'Failed' && (
        <ExclamationCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-400"
          aria-hidden="true"
        />
      )}
      {appRevisionStateToString(props.state) === 'Pending' && (
        <EllipsisHorizontalCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
          aria-hidden="true"
        />
      )}
      {appRevisionStateToString(props.state) === 'Rendering' && (
        <CircularProgress />
      )}
      {appRevisionStateToString(props.state)}
    </span>
  );
}
